// Module
var code = `<ul class="importer-upload-criteria" style="width:400px"> <li> Make sure all the following required columns are filled in:<br/> <ul class="criteria-field-list"> <li>Name</li> <li>Account Code</li> <li>Quantity</li> <li>Unit Type</li> <li>Price</li> <li>Currency</li> <li>Vendor Name</li> </ul> </li> </ul> `;
// Exports
module.exports = code;